import { arrayToMap } from '~/common/utils/arrayToMap';

import type { MarketGroupDetailResponse } from '../services/interfaces/market.types';

import { useEntitiesStore } from './entities.store';
import { useNormalizedMarketsStore } from './normalizedMarkets.store';

export function syncMarketDetailData(data: MarketGroupDetailResponse): void {
  const { events, teams, entities, sub_categories: subCategories } = data.included;

  // Merge entities into the unified EntitiesStore
  useEntitiesStore.getState().mergeEntities(events, teams, entities, subCategories);

  // Sync detail data to NormalizedMarketsStore
  const eventsById = arrayToMap(events);
  useNormalizedMarketsStore.getState().setDetailData(data.market_group, eventsById);
}

export function syncMarketDetailError(error: Error): void {
  useNormalizedMarketsStore.getState().setDetailError(error);
}

export function syncMarketDetailLoading(loading: boolean): void {
  useNormalizedMarketsStore.getState().setDetailLoading(loading);
}

export function syncMarketGroupId(marketGroupId: string | null): void {
  useNormalizedMarketsStore.getState().setActiveMarketGroupId(marketGroupId);
}

export function clearActiveMarketGroupId(marketGroupId: string | null): void {
  const store = useNormalizedMarketsStore.getState();
  if (!marketGroupId || store.activeMarketGroupId !== marketGroupId) return;
  store.setActiveMarketGroupId(null);
}
